import script from "./SearchForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchForm.vue?vue&type=script&lang=ts&setup=true"

import "./SearchForm.vue?vue&type=style&index=0&id=a66bb9fe&scoped=true&lang=scss"

import exportComponent from "C:\\Projects\\wordpress\\stadtwerke-bochum-gut-und-gruen-v2\\wp-content\\themes\\gut-und-gruen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a66bb9fe"]])

export default __exports__